/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	UserValidateCardCreateData,
	UserValidateCardCreateStatus200,
	UserValidateCardCreateStatus404,
	UserValidateCardCreateStatus503,
} from "../types/UserValidateCardCreate.ts";

function getUserValidateCardCreateUrl() {
	const res = { method: "POST", url: `/api/user/validate-card/` as const };

	return res;
}

/**
 * @description Представление авторизации на киоске по номеру карты лояльности.
 * @summary авторизации на киоске по номеру карты лояльности
 * {@link /api/user/validate-card/}
 */
export async function userValidateCardCreate(
	data: UserValidateCardCreateData,
	config: Partial<RequestConfig<UserValidateCardCreateData>> & { client?: Client; contentType?: "application/json" | "application/xml" } = {},
) {
	const { client: request = client, contentType = "application/json", ...requestConfig } = config;

	const requestData = data;

	const res = await request<
		UserValidateCardCreateStatus200,
		ResponseErrorConfig<UserValidateCardCreateStatus404 | UserValidateCardCreateStatus503>,
		UserValidateCardCreateData
	>({ method: "POST", url: getUserValidateCardCreateUrl().url.toString(), data: requestData, contentType, ...requestConfig });

	return res.data;
}
